import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

function CashflowItemDetailSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default CashflowItemDetailSkeleton;
